var map = {
	"./birthday.png": "1a56",
	"./calendarHour.png": "92c9",
	"./calendarHour1.png": "e1cf",
	"./card.png": "ded2",
	"./discountBag.png": "0666",
	"./discountBag1.png": "c434",
	"./first_visit.png": "eb7a",
	"./first_visit1.png": "8be0",
	"./full.png": "8fa7",
	"./moneyBag.png": "9a62",
	"./moneyBag1.png": "bfa2",
	"./new-widget.png": "9f9c",
	"./referral.png": "7374",
	"./truck.png": "b172",
	"./truck1.png": "3728",
	"./wave.png": "1107"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64a2";